<!--  -->
<template>
  <div :class="['resultBox', { miniprogram: this.$root.miniprogram }]">
    <div :class="['activeTitle', { minichat: this.$root.miniprogram }]">
      <button @click="goBack" class="backButton"></button>
      <p class="titleName text-overflow">{{ '趣味活动' }}</p>
    </div>
    <section class="drawReaultCenter">
      <img class="photo" :src="photoUrl" alt="" />
      <img class="cobtn" @click="goDetail" :src="imgsList[7]" alt="" />
    </section>
    <div class="saveBottom">
      <img class="save-btn" :src="imgsList[5]" alt="" @click="toReward" />
      <img class="share-btn" :src="imgsList[6]" alt="" @click="toShare" />
    </div>
    <RewardFloor v-if="showReward" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RewardFloor from './rewardFloor.vue';
import { setBaseUrl, loadMantisChat } from '@/utils/tools';

export default {
  components: {
    RewardFloor,
  },
  data() {
    return {
      aaaa: window.location.href,
      showShare: false,
      showReward: false,
      loading: true,
      photoUrl: '',
      appUrl: '',
      imgsList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/res4.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/res1.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/res5.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/res2.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/res3.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/jiangli.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/zhuanfa.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/funGame/cobtn.png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    goDetail() {
      let drawNum = this.$route.query.drawNum;
      if (drawNum == 1) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/combinationCourse?combinationId=963`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        sessionStorage.setItem('back', true);
        window.location.href = `${setBaseUrl('')}/ark/combinationCourse?combinationId=963`;
        return false;
      }
      if (drawNum == 2) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/combinationCourse?combinationId=963`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        sessionStorage.setItem('back', true);
        window.location.href = `${setBaseUrl('')}/ark/combinationCourse?combinationId=963`;
        return false;
      }
      if (drawNum == 3) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/recommendList?recId=400`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        sessionStorage.setItem('back', true);
        window.location.href = `${setBaseUrl('')}/ark/recommendList?recId=400`;
        return false;
      }
      if (drawNum == 4) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/combinationCourse?combinationId=963`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        sessionStorage.setItem('back', true);
        window.location.href = `${setBaseUrl('')}/ark/combinationCourse?combinationId=963`;
        return false;
      }
      if (drawNum == 5) {
        if (this.$root.$data.isApp) {
          const url = `${window.location.origin}/ark/recommendList?recId=400`;
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        sessionStorage.setItem('back', true);
        window.location.href = `${setBaseUrl('')}/ark/recommendList?recId=400`;
        return false;
      }
    },
    // 取对应图片
    getRoundNum() {
      let drawNum = this.$route.query.drawNum;
      this.photoUrl = this.imgsList[Number(drawNum - 1)];
    },
    // 抽好礼
    toShare() {
      if (this.$root.$data.isApp) {
        const url = `${window.location.origin}/zhuanti/cj/gift?prizeId=149`;
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      sessionStorage.setItem('back', true);
      window.location.href = `${setBaseUrl('')}/zhuanti/cj/gift?prizeId=149`;
    },
    //0元课程
    toReward() {
      this.showReward = true;
    },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
    goBack() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToHomePage');
        return;
      } else if (this.$root.miniprogram) {
        window.history.go(-1);
      } else {
        this.$router.push({
          path: '/',
        });
      }
    },
  },
  created() {
    this.getRoundNum();
    this.change();
    loadMantisChat(this.userInfo);
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.resultBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 100px;
  height: 100vh;
  background: #0c1725;
  .activeTitle {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    font-size: 36px;
    line-height: 100px;
    text-align: center;
    background: #ffff;
    z-index: 1000;

    &.minichat {
      display: none;
      padding-top: 0;
    }
    .backButton {
      position: absolute;
      top: 28.5px;
      left: 31px;
      width: 43px;
      height: 43px;
      background: url('../../../assets/img/header/back-button.png') no-repeat center;
      background-size: contain;
    }

    .titleName {
      padding-right: 200px;
      padding-left: 200px;
      font-weight: 400;
    }
  }

  &.miniprogram {
    padding-top: 0;
  }
  .drawReaultCenter {
    position: relative;
    width: 100%;
    height: calc(100vh - 130px);
    padding-top: 50px;
    padding-bottom: 140px;
    text-align: center;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/funGame/resultBG.png')
      no-repeat center;
    background-size: 100% 100%;
    overflow: auto;

    .photo {
      width: 662px;
      height: 100%;
      background-size: cover;
    }
    .cobtn {
      width: 157px;
      height: 60px;
      position: absolute;
      bottom: 200px;
      right: 80px;
    }
  }
  .saveBottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    background: #fff;
    height: 130px;
    background: #ffffff;
    box-shadow: 0px -5px 8px 0px rgba(95, 172, 120, 0.09);
    border-radius: 40px 40px 0px 0px;
    .save-btn {
      width: 300px;
      height: 152px;
      margin-top: -70px;
      margin-right: 30px;
    }
    .share-btn {
      width: 300px;
      height: 152px;
      margin-top: -70px;
    }
  }
}
</style>
